<template>
  <select-with-buttons :options="playerOptions" row-size="3" @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';

export default {
  name: 'SelectPlayer',
  components: {SelectWithButtons},
  props: {},
  computed: {
    playerOptions() {
      const d = key => this.$t('directions.' + key);
      return [
        null,
        {text: d('N'), value: 0, class: ['scoreButton']},
        null,
        {text: d('W'), value: 3, class: ['scoreButton']},
        null,
        {text: d('E'), value: 1, class: ['scoreButton']},
        null,
        {text: d('S'), value: 2, class: ['scoreButton']},
        null
      ];
    }
  },
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>

>>> .scoreButton {
  background: #fff;
  border: 1.5px solid #1e3a5f;
  color: #1e3a5f;
  font-weight: 600;
}
</style>